import { fetchWrapper } from '../helpers';

const baseUrlAPI = `${process.env.API_BASE_URL}/faq`;

export const faqService = {
  getFAQ,
  getFAQList,
  getTargets,
  saveFAQ,
  deleteFAQ,
  // Studio & Prompts capabilities
  getPrompts,
  getPromptVersions,
  savePrompt,
  activatePromptVersion,
  saveCSVHistory,
  getCSVHistory,
  saveRunState,
  getRunsList,
  publishFAQ
};

function getFAQ(categoryMapId) {
  return fetchWrapper.get(`${baseUrlAPI}?category_map_id=${categoryMapId}`);
}

function getFAQList() {
  return fetchWrapper.get(`${baseUrlAPI}/list`);
}

function getTargets() {
  return fetchWrapper.get(`${baseUrlAPI}/targets`);
}

function saveFAQ(categoryMapId, faqJson) {
  return fetchWrapper.post(`${baseUrlAPI}`, { category_map_id: categoryMapId, faq_json: faqJson });
}

function deleteFAQ(categoryMapId) {
  return fetchWrapper.delete(`${baseUrlAPI}/${categoryMapId}`);
}

function getPrompts() {
  return fetchWrapper.get(`${baseUrlAPI}/prompts`);
}

function getPromptVersions(promptId) {
  return fetchWrapper.get(`${baseUrlAPI}/prompts/${promptId}/versions`);
}

function savePrompt(promptData) {
  return fetchWrapper.post(`${baseUrlAPI}/prompts`, promptData);
}

function activatePromptVersion(promptId, version) {
  return fetchWrapper.post(`${baseUrlAPI}/prompts/activate`, { prompt_id: promptId, version: parseInt(version) });
}

function saveCSVHistory(csvData) {
  return fetchWrapper.post(`${baseUrlAPI}/studio/csv`, csvData);
}

function getCSVHistory(categoryMapId) {
  return fetchWrapper.get(`${baseUrlAPI}/studio/csv/versions/${categoryMapId}`);
}

function saveRunState(runData) {
  return fetchWrapper.post(`${baseUrlAPI}/studio/run`, runData);
}

function getRunsList() {
  return fetchWrapper.get(`${baseUrlAPI}/studio/runs`);
}

function publishFAQ(publishData) {
  return fetchWrapper.post(`${baseUrlAPI}/studio/publish`, publishData);
}
